import axios from 'axios'

export const getMarketsByTerm = async (
  term,
  token,
  size,
  locale,
  hideAllMarkets = false,
  isProfileCompletion = false
) => {
  const url = process.env.GATSBY_API_MARKET_SEARCH
  const headers = { Authorization: `Bearer ${token}` }
  const params = { op: 'byTerm', term, size }
  const res = await axios({
    method: 'get',
    url,
    headers,
    params
  })

  const localeItems = res.data.hits.hits.filter(
    hit => hit._source.countryCode.toLowerCase() === locale
  )

  const items = hideAllMarkets
    ? localeItems.map(hit => ({
        marketData: hit._source,
        highlight: hit.highlight
      }))
    : res.data.hits.hits.map(hit => ({
        marketData: hit._source,
        highlight: hit.highlight
      }))

  const loyaltyMarkets = items.filter(item => item.marketData.isLoyaltyMarket)

  return {
    response: res,
    numberOfItems: res.data.hits.hits.length,
    result: isProfileCompletion ? loyaltyMarkets : items
  }
}
